import { Button, Form, Input, message } from "antd";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";

interface EditProjectDescriptionModalProps extends ModalComponentProps {
  currentDescription: string;
  projectId: number;
  editProjectDescription: (projectId: number, payload: API_PGAdminProjectChanges) => Promise<void>;
}

export const EditProjectDescriptionModal = ({
  currentDescription,
  projectId,
  editProjectDescription,
  hideModal,
}: EditProjectDescriptionModalProps) => {
  const { t } = useTranslation([I18N_NS.ADMIN, I18N_NS.PROJECT]);
  const handleFinish = async (value) => {
    try {
      await editProjectDescription(projectId, { newProjectDescription: value?.newProjectDescription });
      message.success(t("Success"));
      hideModal();
    } catch (error) {
      throw error;
    }
  };

  return (
    <Form onFinish={handleFinish}>
      <Form.Item
        name="newProjectDescription"
        label={t("Description")}
        rules={[{ required: true, message: t("This field is required") }]}
        initialValue={currentDescription}
      >
        <Input />
      </Form.Item>
      <ButtonsRow justify="end">
        <Button htmlType="submit" type="primary">
          {t("Edit")}
        </Button>
      </ButtonsRow>
    </Form>
  );
};
